import React from 'react';
import { useState } from "react";
//import { MyContext } from "../../context";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";



function TicketProcessInstallCard(){

    const [value, setValue] = useState()

    console.log(value)

return (
       
    <>
    <div className="card p-3 mb-4">
                <div className="d-flex justify-content-between">
                    <div className="d-flex flex-row align-items-center">
                        <div className="iconCard"> 
                        <span className="material-symbols-rounded">Footprint</span>
                         </div>
                        <div className="ms-2 c-details">
                            <h6 className="mb-0">Process</h6>{/* <span>Pending Ticket Approval</span> */}
                        </div>
                    </div>
                    <div className="badge Process"> <span className='badgeSize'>Re-installation</span> </div>
                </div>
                <div className="mt-3">
                    

               

<p><strong>Contact Details </strong></p>

<div className='smallInfo' style={{display: "flex"}}>
    
    
    <span class="material-symbols-rounded writing" style={{paddingLeft:"0px"}}>phone</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Phone: </strong>094 948 9874</span>

<span className="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>email</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Email: </strong>z-Range</span>


<span className="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>location_on</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>Randburg</span>


</div>

<hr />

<select  id="cars" name="cars" className="Login-form-field Login-animation a4 selectForm" style={{ marginTop: "10px", width:"50%" }}>
          <option value="" disabled selected>Repairs Status</option>
    <option value="Z-Range">Parkaging</option>
    <option value="Giga-Rack">Commission</option>
  </select>

<hr/>
<input
            type="number"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Loan Units"
            style={{ marginTop: "10px", width:"50%"  }}
            />
<hr />

{/* */}


                    <div className="mt-3">
                       
                    <div className='smallInfo' style={{display: "flex", justifyContent:"end"}}>

                        {/*
  <span className="BIcon3" onClick={""} style={{height:"100%" , margin: "0px",  paddingTop:"6px", fontSize:"12px", marginRight: "20px", paddingLeft:"15px", width:"30%"}}><span class="material-symbols-rounded size"  style={{paddingTop:"3px"}} >directions_car</span> <span style={{paddingTop:"7px", paddingLeft:"5px"}}></span ><span style={{paddingTop:"6px"}} >Visit site date</span></span>

  <span className="BIcon3" onClick={""} style={{height:"100%" , margin: "0px",  paddingTop:"6px", fontSize:"12px", marginRight: "20px", paddingLeft:"15px", width:"30%"}}><span class="material-symbols-rounded size"  style={{paddingTop:"3px"}} >post_add</span> <span style={{paddingTop:"7px", paddingLeft:"5px"}}></span ><span style={{paddingTop:"6px"}} >Add Report</span></span> */}

  <span className="BIcon3" onClick={""} style={{height:"100%" , margin: "0px",  paddingTop:"6px", fontSize:"12px", paddingLeft:"15px", width:"30%"}}><span class="material-symbols-rounded size"  style={{paddingTop:"3px"}} >build</span> <span style={{paddingTop:"7px", paddingLeft:"5px"}}></span ><span style={{paddingTop:"6px"}} >Re-Installation </span></span>



  </div>

                    </div>
                </div>
            </div>
    </>
)

}

export default TicketProcessInstallCard;